import { Box, IconButton } from '@chakra-ui/react';
import { useState } from 'react';
import { FaArrowCircleUp } from 'react-icons/fa';

import { Paper, TextField, Txt } from '@app/components/common';

export type PromptInputProps = {
  loading: boolean;
  onSubmit: (value: string) => void;
};

export const PromptInput = ({ loading, onSubmit }: PromptInputProps) => {
  const [value, setValue] = useState('');

  const onSend = () => {
    if (value.length < 3 || loading) {return;}
    onSubmit(value);
    setValue('');
  };

  return <Paper>
    <Box display='flex' px={3} pt={4} gap={2}>
      <TextField 
        label='Введите ваш вопрос'
        multiline onChange={setValue} value={value} id='input' 
        max={300}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && e.ctrlKey) {
            onSend();
          }
        }}
      /> 
      <Box flex={1} flexDirection='column' justifyContent='center' alignItems='center' >
        <IconButton isLoading={loading} onClick={onSend} aria-label='' backgroundColor='transparent' color='brand.500' w='24px'> 
          <FaArrowCircleUp size='24px' />
        </IconButton>
        <Txt color='gray.500' fontSize={10}>Ctrl+Enter</Txt>
      </Box>
    </Box>
    <Box px={3}>
      <Txt fontSize={10} color='gray.500' mt={2}>Минимум 3 символа, максимум 300</Txt>
    </Box>
  </Paper>;
};